/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA
 *
 */

import request, { getEndpointUrl } from '@/core/apiRequest/apiRequest';

/**
 * @typedef {Object} CreateIntegrationUserData
 * @property {string} integrationId - Integration ID (for eg. feide or idporten)
 * @property {string} userId - User id that needs to be created (for eg. SSN number or D-number)
 */

/**
 * @typedef {Object} UserIntegrationButtonConfig
 * @property {string} id - Integration id
 * @property {string} label - Button text
 */

/**
 * @typedef {Object} UserIntegrationPageConfig
 * @property {string} title - Page title
 * @property {string} inputLabel - Input label text
 */

/**
 * @typedef {Object} UserIntegrationConfig
 * @property {Array<UserIntegrationButtonConfig>} buttons - Button configurations
 * @property {Object.<string, UserIntegrationPageConfig>} pages - Page configurations
 */

/**
 *
 * @param {CreateIntegrationUserData} formData
 * @returns {Promise<{login: string}>}
 */
export const createIntegrationUser = formData =>
    request(getEndpointUrl('userCreateIntegration'), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    });

/**
 * @returns {Promise<UserIntegrationConfig>}
 */
export const getIntegrationUserConfiguration = () =>
    request(getEndpointUrl('userIntegrationConfiguration'), {
        method: 'GET'
    });
